/**
 * Known client-side environment variables.
 */
export interface ClientSideEnvironment {
  AUTH0_AUDIENCE_URL: string
  AUTH0_CLIENT_ID: string
  AUTH0_DOMAIN: string
  BILLING_API: string
  CSDESK_API: string
  DOCUMENT_API: string
  FLOCK_API: string
  FRESHBOOKS_API_EXTERNAL: string
  HQ_URL: string
  HUBSPOT_PORTAL_ID: string
  IAM_API: string
  LAUNCHDARKLY_CLIENT_SIDE_ID: string
  LEGEND_API: string
  MESSAGE_API: string
  NOTIFICATION_API: string
  ORIGIN_WORTAL: string
  POSTHOG_KEY: string
  IMPERSONATED_PROVIDER_PORTAL_URL: string
  CLIENT_PORTAL_URL: string
  STRIPE_PK: string
  STRIPE_CONNECT_ID: string
  WORK_DOTNET_API: string
  WUNDER_API: string

  // BigMoney is optional.
  BIGMONEY_API?: string

  // Realtime events from Wunder API are optional.
  WUNDER_API_EVENTS?: boolean

  TXF_PORTAL_URL: string
}

/**
 * The environment variables for the client.
 */
export const env: ClientSideEnvironment =
  typeof window !== 'undefined'
    ? (window.__env ?? ({} as ClientSideEnvironment))
    : ({} as ClientSideEnvironment)
